module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/basketballIcon-d5cfa0f50385ae70e84b6402be053822.svg";